module.exports = __webpack_public_path__ + "img/googlecloud-black.97b7b8d5.png";